import { VisitaGuiada } from '../../domain/entities/VisitaGuiada';
import { VisitaGuiadaRepository } from '../../domain/repositories/VisitaGuiadaRepository';

export class GetVisitasGuiadasUseCase {
  constructor(private visitaRepository: VisitaGuiadaRepository) {}

  async execute(): Promise<VisitaGuiada[]> {
    return await this.visitaRepository.findUpcoming();
  }
} 